import React from 'react';
import { Carousel } from 'antd-mobile';

import './PreviewImage.less';

export class PreviewImage extends React.Component {
  constructor(props) {
    super(props);
    this.options = this.props.options;
    const current = this.options.current;
    this.urls = this.options.urls || (current ? [current] : []);
    let index = this.urls.indexOf(current);
    this.selectedIndex = index > -1 ? index : 0;

    this.state = {
      selectedIndex: this.selectedIndex
    }

    this.carouselAfterChange = this.carouselAfterChange.bind(this);
  }

  carouselAfterChange(index){
    this.setState({ selectedIndex: index });
  }

  imgClick(event){
    event.stopPropagation();
  }

  close(event){
    ReactDOM.unmountComponentAtNode(document.getElementById('popup'));
  }

  render() {
    return (
      <div className="common-api preview-image">
        <div className="preivew-image-dots">{this.state.selectedIndex + 1}/{this.urls.length}</div>
        <Carousel
          selectedIndex={this.selectedIndex} 
          dots={false} 
          afterChange={this.carouselAfterChange}
        >
          {this.urls.map((item, itemIndex) => (
            <div className="preview-image-item" key={itemIndex} onClick={this.close}>
              <img
                src={item}
                alt="" 
                onClick={this.imgClick}
              />
            </div>
          ))}
        </Carousel>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/common/preview-image/PreviewImage.jsx